import Proveedor from "./Proveedor";
import { withRouter } from "react-router-dom";

export default withRouter(Proveedor);
